import {useCommand} from 'hooks';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {CreateQuestionDialog} from './CreateQuestionDialog';
import {isDevEnvironment, isTestEnvironment} from 'appShell/Layout/Navigation';
import {useEntityContext} from 'components/EntityPage/EntityContext';
import {UserRole} from 'types';
import {useStore} from 'react-context-hook';
import {IFaqState} from './FaqPanel';

export const FaqCommand = (props: {faqState: IFaqState}) => {
	const {t} = useTranslation('common/faq');
	const [showQuestionDialog, setShowQuestionDialog] = React.useState(false);
	const [faqPanelState, setFaqPanelState] = useStore<IFaqState>('faq-panel');
	const {selectedItems} = useEntityContext<any>();

	useCommand(
		{
			key: 'PostQuestionButton',
			priority: 10,
			text: t('PostQuestionButton'),
			iconProps: {iconName: 'Chat'},
			onClick() {
				setShowQuestionDialog(true);
				setFaqPanelState(props.faqState);
			},
			hidden: !(isDevEnvironment() || isTestEnvironment()),
			disabled: selectedItems?.length !== 1,
			roles: [UserRole.SystemAdministrator, UserRole.Vex],
		},
		[selectedItems],
	);

	return (
		<>
			{showQuestionDialog && (
				<CreateQuestionDialog
					showDialog={showQuestionDialog}
					setShowDialog={setShowQuestionDialog}
				/>
			)}
		</>
	);
};
